import React, { Component } from "react";
import Layout from "../layout/Main";
import Header from "../components/Regulation/Header";
import MenuTab from "../components/Regulation/MenuTab";
import RegulationTab from "../components/Regulation/RegulationTab";
import GuidenTab from "../components/Regulation/GuidenTab";
import { http, baseURL } from "../misc/http";
import InfoGraphic from "../components/Event/InfoGraphic";
export default class Regulation extends Component {
  state = {
    activeTab: "regulation",
    collapse: "",
    listRegulation: [],
    listGuide: [],
    listInfoGraphic: [],
  };

  componentDidMount = () => {
    this.handleGetAll();
    this.handleGetAll("infographic?status=publish", "listInfoGraphic");
  };

  handleGetAll = async (path = "regulation", stateName) => {
    let params = {
      method: "GET",
      path,
      showMessage: false,
    };
    let { data } = await http(params);
    // console.log("checking data ", data);
    if (data.code === 200) {
      if (path === "regulation") {
        let { listRegulation, listGuide } = this.state;
        if (Array.isArray(data.data))
          data.data.forEach((e) => {
            if (e.regulationFile) e.regulationFile = baseURL + e.regulationFile;
            if (e.type === "regulation") listRegulation.push(e);
            else listGuide.push(e);
          });
          console.log('listRegulation ', listRegulation)
        this.setState({ listRegulation, listGuide });
      } else {
        this.setState({ [stateName]: data.data });
      }
    }
  };

  handleChangeTab = (activeTab) => {
    this.setState({ activeTab });
  };

  renderTab = () => {
    switch (this.state.activeTab) {
      case "regulation":
        return (
          <RegulationTab
            handleCollapse={this.handleCollapse}
            collapse={this.state.collapse}
            listRegulation={this.state.listRegulation}
          />
        );
      case "guiden":
        return (
          <GuidenTab
            collapse={this.state.collapse}
            handleCollapse={this.handleCollapse}
            listGuide={this.state.listGuide}
          />
        );

      case "infographic":
        return (
          <InfoGraphic
            listInfoGraphic={this.state.listInfoGraphic}
            baseURL={baseURL}
          />
        );

      default:
        break;
    }
  };

  handleCollapse = (collapse) => {
    if (collapse === this.state.collapse) collapse = "";
    this.setState({ collapse });
  };

  render() {
    return (
      <Layout>
        <Header />
        <section class="kegiatan-acara-saya">
          <MenuTab
            activeTab={this.state.activeTab}
            handleChangeTab={this.handleChangeTab}
          />
          <div class="container">
            <div class="tab-content" id="pills-tabKegiatanAcara">
              {this.renderTab()}
            </div>
          </div>
        </section>
      </Layout>
    );
  }
}
